import { Checkbox } from "../../ui/checkbox";
import { TimeInputGroup } from "./TimeInputGroup";

export const MealBreakSection = ({ mealBreak, onToggle, onTimeChange, disabled, translations }) => {
  const mealBreakData = mealBreak || { enabled: false, startTime: '', endTime: '' };

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <Checkbox
          checked={disabled ? false : mealBreakData.enabled}
          onCheckedChange={onToggle}
          disabled={disabled}
        />
        <span>{translations("form.schedule.mealBreak")}</span>
      </div>
      {mealBreakData.enabled && !disabled && (
        <div className="ml-6 space-y-2">
          <TimeInputGroup
            label={translations("form.schedule.start")}
            day="Today"
            time={mealBreakData.startTime}
            onTimeChange={(v) => onTimeChange("startTime", v)}
            translations={translations}
          />
          <TimeInputGroup
            label={translations("form.schedule.end")}
            day="Today"
            time={mealBreakData.endTime}
            onTimeChange={(v) => onTimeChange("endTime", v)}
            translations={translations}
          />
        </div>
      )}
    </div>
  );
};